import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import axios from "axios"
import { useState } from "react"
import { toast } from "react-toastify"

export interface VesselLogs {
  id: string
  vesselImo: string
  tagId: string
  comment: string
  createdBy: string
  createdAt: string
  tagName: string
}

export interface FetchLogsParams{
  imo: number,
  orgId: string
}

export function useFetchLogs() {
  const [vesselLogs, setVesselLogs] = useState<VesselLogs[]>()
  const [isFetchVesselLogsLoading, setIsFetchVesselLogsLoading] =
    useState<boolean>(false)
  const request = useAxiosRequest()
  async function fetchLogs(args: FetchLogsParams) {
    try {
      setIsFetchVesselLogsLoading(true)
      const data = await request<any, VesselLogs[]>({
        url: `${BASE_URL}/prevetting/logs`,
        params: { imo: args.imo, orgId: args.orgId },
      }).then((response) => response?.data)
      setVesselLogs(data)
    } catch (err: unknown) {
      const message = "Unable to get logs"
      if (axios.isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setIsFetchVesselLogsLoading(false)
    }
  }

  return {
    vesselLogs,
    fetchLogs,
    isFetchVesselLogsLoading,
  }
}
